export default __webpack_public_path__ + "static/media/f8.de7e6a33.jpg";